import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, makeStyles, mergeClasses, Text } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';
import './ConfirmPartnerIdModal.scss';

interface ConfirmPartnerIdModalProps {
  onClose: () => void;
  onConfirm: () => void;
  partnerId: string;
}

const useStyles = makeStyles({
  modalSurface: {
    maxWidth: '464px',
  }
});

const ConfirmPartnerIdModalImpl: React.FC<ConfirmPartnerIdModalProps> = (props) => {
  const {
    onClose,
    onConfirm,
    partnerId,
  } = props;

  const commonStyles = useCommonStyles();
  const styles = useStyles();

  return (
    <Dialog
      open
      onOpenChange={(_, data) => {
        if (!data.open) onClose();
      }}
    >
      <DialogSurface
        className={mergeClasses(commonStyles.modalSurface, styles.modalSurface, 'confirm-partner-id-modal')}
      >
        <DialogBody
          className={commonStyles.modalBody}
        >
          <DialogTitle
            action={(
              <Button
                appearance='transparent'
                icon={<Dismiss24Regular />}
                onClick={onClose}
              />
            )}
          >
            Confirm Partner ID
          </DialogTitle>

          <DialogContent>
            <Text
              as='p'
              block
            >
              Please confirm that the Partner ID below is correct. If not, please go back and enter the correct Partner ID.
            </Text>
            <Text
              size={600}
              block
              weight='semibold'
              align='center'
            >
              {partnerId}
            </Text>
          </DialogContent>
          <DialogActions>
            <Button
              appearance='secondary'
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              appearance='primary'
              onClick={onConfirm}
            >
              Confirm
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export const ConfirmPartnerIdModal = observer(ConfirmPartnerIdModalImpl);
